const ERROR_CODES = {
  archetypeMismatch: "ARCHETYPE_MISMATCH",
  locationMismatch: "LOCATION_MISMATCH",
  authenticationError: "AUTHENTICATION_ERROR"
};

export default ERROR_CODES;
